// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class ImageTextCarousel extends window.BAO.CarouselElement {
  static get requiredElements () {
    return ['carousel']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.dataset.autoplay === 'true') {
      this.interval = 0
      this.autoplay = (run, instance) => {
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          if (run && instance) {
            instance.next()
          }
        }, this.dataset.autoplayDuration)
      }
    }
    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      duration: this.dataset.autoplayDuration,
      selector: this.els.slide.selector,
      drag: true,
      loop: this.dataset.autoplay,
      mode: 'snap',
      rubberband: true,
      slides: {
        origin: 'auto',
        perView: 1.15,
        spacing: 15,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 1.1,
            spacing: 30,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: 1.1,
            spacing: 30,
          },
        },
      },
      created: instance => {
        if (this.dataset.autoplay === 'true') {
          this.els.slides.element.addEventListener('mouseover', () => {
            this.autoplay(false, instance)
          })
          this.els.slides.element.addEventListener('mouseout', () => {
            this.autoplay(true, instance)
          })
          this.autoplay(true, instance)
        }
      },
      optionsChanged: instance => {
        this.onOptionsChange(instance)
      },
      slideChanged: instance => {
        this.onSlideChange(instance)
      },
    })
  }

  onSlideChange (instance) {
    const details = instance?.track?.details
    if (!details) return
    this.updateStyles(details?.rel)
  }

  onOptionsChange (instance) {
    const details = instance?.track?.details
    if (!details) return
    this.updateStyles(details?.rel)
  }

  updateStyles (index) {
    if (!index && index !== 0) return
    const slideEl = this.els.slide.elements.find(
      slideEl => slideEl.dataset?.slide === index.toString(),
    )
    if (!slideEl) return
    this.backgroundColour = slideEl?.dataset?.backgroundColour
    this.textColour = slideEl.dataset?.textColour
  }

  set backgroundColour (hexCode = `#F6F6F6`) {
    this.style.setProperty(`--BackgroundColour`, `${hexCode}`)
  }

  get backgroundColour () {
    this.style.getProperty(`--BackgroundColour`)
  }

  set textColour (colour) {
    this.setAttribute(`data-text-colour`, colour.toLowerCase())
  }

  get textColour () {
    return this.dataset?.textColour || 'light'
  }

  get carouselEl () {
    return this.els?.carousel?.element
  }
}

if (!customElements.get('image-text-carousel')) {
  customElements.define('image-text-carousel', ImageTextCarousel)
}
